module.exports = __webpack_public_path__ + "img/faucet.7355830b.svg";